<button class="toggle-button"
	[ngClass]="{'selected': value}"
	[tabindex]="tabIndexNum"
	id="{{value ? onOffSwitchId+'_toggle_on' : onOffSwitchId+'_toggle_off'}}"
	(click)="sendChangeEvent($event)"
	[value]="value"
	[name]="onOffSwitchId"
	[attr.aria-label]="value ? toggleId+' on' : toggleId+' off'"
	(focus)="hideColorPicker()">
	<button tabindex="-1"
		id="ui-toggle-on-off-switchId"
		class="btnRound"
		[ngClass]="{'selected': value}"
		[attr.name]="onOffSwitchId"
		[value]="value"></button>
</button>
